import React from "react";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import Avatar from "components/common/Avatar";

/**
 * Figma 8068:148705 — "Profile Card"
 * Avatar (blue ring) + name + verified badge + divider + email/phone.
 */
const ProfileIdentityCard = ({
  avatarSrc,
  fullName,
  isVerified = false,
  email,
  mobileNo,
  topRightSlot,
}) => (
  <Box
    sx={{
      position: "relative",
      bgcolor: "#fff",
      border: "1px solid #E2E8F0",
      borderRadius: "20px",
      boxShadow: "0px 4px 10px rgba(0,0,0,0.02)",
      p: { xs: 3, md: 4 },
    }}
  >
    {topRightSlot ? (
      <Box sx={{ position: "absolute", top: 12, right: 12 }}>
        {topRightSlot}
      </Box>
    ) : null}
    <Stack alignItems="center" spacing={3} sx={{ width: "100%" }}>
      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: "999px",
          border: "3px solid #3B82F6",
          p: "4px",
          boxSizing: "border-box",
        }}
      >
        <Avatar
          src={avatarSrc}
          title={fullName}
          variant="h4"
          sx={{ width: "100%", height: "100%" }}
        />
      </Box>

      <Stack alignItems="center" spacing={1} sx={{ width: "100%" }}>
        <Text
          sx={{
            fontWeight: 700,
            fontSize: "24px",
            color: "#111827",
            textAlign: "center",
            wordBreak: "break-word",
          }}
        >
          {fullName}
        </Text>
        {isVerified ? (
          <Stack
            direction="row"
            alignItems="center"
            spacing={0.5}
            sx={{
              bgcolor: "#DCFCE7",
              borderRadius: "999px",
              px: 1.5,
              py: 0.5,
              width: "fit-content",
            }}
          >
            <Box
              component="img"
              src="/images/profile-v2/badge-check.svg"
              alt=""
              sx={{ width: 16, height: 16 }}
            />
            <Text
              sx={{ fontWeight: 600, fontSize: "12px", color: "#10B981" }}
            >
              Verified Account
            </Text>
          </Stack>
        ) : null}
      </Stack>
    </Stack>

    <Box sx={{ height: "1px", bgcolor: "#E2E8F0", width: "100%", my: 3 }} />

    <Stack spacing={2} sx={{ width: "100%" }}>
      {email ? (
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            component="img"
            src="/images/profile-v2/mail.svg"
            alt=""
            sx={{ width: 20, height: 20, flexShrink: 0 }}
          />
          <Text
            sx={{
              fontSize: "14px",
              color: "#4B5563",
              wordBreak: "break-word",
            }}
          >
            {email}
          </Text>
        </Stack>
      ) : null}
      {mobileNo ? (
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            component="img"
            src="/images/profile-v2/phone.svg"
            alt=""
            sx={{ width: 20, height: 20, flexShrink: 0 }}
          />
          <Text sx={{ fontSize: "14px", color: "#4B5563" }}>{mobileNo}</Text>
        </Stack>
      ) : null}
    </Stack>
  </Box>
);

export default ProfileIdentityCard;
